/**
 * HttpError — Error subclass that carries the HTTP status code from a
 * non-2xx fetch response so callers can branch on the specific status
 * (e.g. 401 → token re-entry, 403 → forbidden view, others → toast).
 */
export class HttpError extends Error {
  public readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    // Maintain proper prototype chain when targeting ES5/older transpilers.
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
